/* ===== グローバルナビ ORDER サブメニュー（SPアコーディオン開閉） ===== */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest ? e.target.closest('.h-submenu_toggle') : null;
    if (!toggle) return;
    e.preventDefault();
    var parentLi = toggle.closest('.h-has_child');
    if (!parentLi) return;
    var submenu = parentLi.querySelector('.h-submenu');
    if (!submenu) return;
    var open = submenu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();
